import React, {useEffect, useState} from 'react';
import {
    Accordion,
    AccordionDetails, Checkbox,
    FormControlLabel,
    FormGroup,
    ListItem,
    Radio,
    RadioGroup,
} from '@mui/material';
import AccordionSummary from "@mui/material/AccordionSummary";
import Typography from "@mui/material/Typography";
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import makeStyles from "@mui/styles/makeStyles";
import List from "@mui/material/List";
import ListItemButton from "@mui/material/ListItemButton";
import clsx from "clsx";
import {useDispatch, useSelector} from "react-redux";
import {
    getAdmissionConfig,
    getAllTheatresDict,
    getConfig,
    getSpecialtiesDict, setConsultantsFilter,
} from '../../../store/reducers/booked_admissions';
import Chip from "@mui/material/Chip";
import {agylePref, saveAgylePreference, saveCurrentTheme} from '../../../store/reducers/preferences';
import Button from "@mui/material/Button";
import {AdminAPI} from '../../admin/admin_api';
import {setSnackbar} from '../../../store/reducers/globals';
import Grid from '@mui/material/Grid';
import {useTranslation} from 'react-i18next';
import LockIcon from '@mui/icons-material/Lock';
import Avatar from '@mui/material/Avatar';
import _ from 'lodash';
import LockOpenIcon from '@mui/icons-material/LockOpen';
import TextField from '@mui/material/TextField';
import {WorkloadTypes, ShowOptionTypes, TableDataShowTypes} from '../dashboard/dashboardUtils';
import {hasBAPermission, Permissions, user} from '../../../store/reducers/user';
import {AdmissionConsultant} from '../../../controls/agyle/dictionaries';
import AgyleSwitch from '../../../components/ui/switch/agyleSwitch';
import API from '../../../app/api';
import AgyleToggleButtons from '../../../components/ui/buttons/agyleToggleButtons';
import {bookAdmissionToggleStyles} from '../bookedAdmissions';

export const useStyles = makeStyles((theme) => ({
    menu: {
        width: "25%",
        paddingRight: 10,
        borderRight: "1px solid #ffffff1f",
        height: "calc(100vh - 100px)"
    },
    content: {
        paddingLeft: 10,
        width: "75%",
        height:  "calc(100vh - 100px)",
        overflow: "auto"
    },
    menuItem: {
        display: "flex",
        alignItems: "center",
        color: "grey"
    },
    menuItemSelected: {
        borderRadius: 10,
        borderRight: "3px solid #2180F7",
        display: "flex",
        alignItems: "center",
        color: theme.palette.bookAdmissions.settingMenuItemSelectedText,
        backgroundColor: theme.palette.bookAdmissions.settingMenuItemSelectedBackground
    },
    saveButton: {
        width: "100%",
        display: "flex",
        justifyContent: "flex-end",
        paddingRight: "20px",
        position: "absolute",
        top: 12,
        right: 35
    },
    accordion: {
        backgroundColor: theme.palette.bookAdmissions.settingAccordionBackground
    },
    typography: {
        width: "100%"
    },
    headerContainer: {
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center"
    }

}));

const SettingsModal = (props) => {
    const classes = useStyles();
    const {t} = useTranslation();

    const [selectedTab, setSelectedTab] = React.useState("Customization Cards")
    const [cardPref, setCardPref] = React.useState(null);

    const config = useSelector(getConfig);
    const agylePreference = useSelector(agylePref);
    const dispatch = useDispatch();
    const isTAdmin = dispatch(hasBAPermission(Permissions.BA_IS_THEATRES_ADMIN));
    const isMDUAdmin = dispatch(hasBAPermission(Permissions.BA_IS_MDU_ADMIN));
    const [canConfigureDefaults, setCanConfigureDefaults] = useState(false);
    const [menuItem, setMenuItem] = useState([{title: "Customization Cards"},
        {title: "Customization"},
        {title: "Customization Default Cards Settings"},
        {title: "Customization Default Settings"},
        {title: "Customization Dashboard"},
        {title: "Customization Dashboard Default Settings"}]);

    const resetText = "Reset to Default";
    const userObject = useSelector(user);

    useEffect(()=>{
        const tmpCanConfigureDefaults = isTAdmin || isMDUAdmin;
        setCanConfigureDefaults(tmpCanConfigureDefaults);
        if(tmpCanConfigureDefaults){
            setMenuItem([{title: "Customization Cards"},
                {title: "Customization"},
                {title: "Customization Default Cards Settings"},
                {title: "Customization Default Settings"},
                {title: "Customization Dashboard"},
                {title: "Customization Dashboard Default Settings"}]);
        } else {
            setMenuItem([{title: "Customization Cards"},
                {title: "Customization"},
                {title: "Customization Dashboard"}]);
        }
    }, [isTAdmin, isMDUAdmin]);

    const savePref = () => {
        setNeedSave(false);
        dispatch(saveAgylePreference({bookedAdmissionsCardConfig: cardPref}));
    }

    const savePrefDef = () => {
        AdminAPI.updateMasterRecordFieldData("admissionConfig", "cardSetting", cardConfigTmp).then(result => {
          // console.log(result);
        //   setNeedSave(false);
        //   dispatch(getAdmissionConfig());
            AdminAPI.updateMasterRecordFieldData("admissionConfig", "cardSettingLock", cardConfigLockTmp).then(result => {
                // console.log(result);
                setNeedSave(false);
                dispatch(getAdmissionConfig());
                dispatch(setSnackbar({
                    type: "success",
                    message: "Saved",
                }));
            })
        })

    }

    const handleSetCardPref = () => {
        let preferences = {...agylePreference.bookedAdmissionsCardConfig}

        if(config) {
            Object.keys(config.cardSetting).map((key) => {
                if(!preferences[key]) {
                    preferences[key] = config.cardSetting[key]
                }
            })

        }
        setCardPref(preferences);
    }

    useEffect(() => {
        handleSetCardPref();
        if(agylePreference.bookedAdmissions && agylePreference.bookedAdmissions.dashboard){
            if(agylePreference.bookedAdmissions.dashboard.specialtiesSet) {
                setSelectedSpecialties([...(_.cloneDeep(agylePreference.bookedAdmissions.dashboard.specialtiesSet))]);
            }
            if(agylePreference.bookedAdmissions.dashboard.theatersSet) {
                setSelectedTheaters([...(_.cloneDeep(agylePreference.bookedAdmissions.dashboard.theatersSet))]);
            }
            buildColorSet();
        }
    },[agylePreference])

    const addFiled = (field, type) => {
        setCardPref((pr) => {
            let list = {...pr[type]};
            list[field.key] = !list[field.key];
            return {
                ...pr,
                [type]: list
            }
        })
        setNeedSave(true);
    }

    const selectFiled = (field, type) => {
        setCardPref((pr) => {
            let list = {...pr[type]};
            list[field.key] = true;
            return {
                ...pr,
                [type]: list
            }
        })
        setNeedSave(true);
    }

    const addFiledDef = (field, type) => {
        setCardConfigTmp((pr) => {
            let list = {...pr[type]};
            list[field.key] = !list[field.key];
            return {
                ...pr,
                [type]: list
            }
        })
        setNeedSave(true);
    }
    const resetToDefault = (e, type) => {
      //  console.log(cardConfigTmp, type);
        // let preferences = {...cardConfigTmp}
        // preferences[type] = config.cardSetting[type]
        // setCardPref(preferences);
        // setNeedSave(true);

        setCardPref((pr) => {
            let list = config.cardSetting[type]
            return {
                ...pr,
                [type]: list
            }
        })
        setNeedSave(true);
        e.stopPropagation();
        e.preventDefault();
    }
    const resetToLock = (e, type) => {
        setCardPref((pr) => {
            let list = cardConfigLockTmp[type]
            return {
                ...pr,
                [type]: list
            }
        })
        setNeedSave(true);
    }

    const resetToDefaultPref = (event, preferenceName, defaultPath) => {
        const defPathArray = defaultPath.split(".");
        let defValue = config[defPathArray[0]];
        if(defaultPath.length > 1) {
            for (let i = 1; i < defPathArray.length; i++) {
                if (defValue.hasOwnProperty(defPathArray[i])) {
                    defValue = defValue[defPathArray[i]];
                } else {
                    defValue = null;
                    i = defPathArray.length;
                }
            }
        }
        dispatch(saveAgylePreference(handleChangePreference(defValue, preferenceName)));
        event.stopPropagation();
        event.preventDefault();
    }

    const convertToArray = (dayCardColorRanges) => {
        let array = [];
        Object.keys(dayCardColorRanges).map((key) => {
            array.push({
                range: key,
                ...dayCardColorRanges[key]
            })
        })
        return array;
    }

    useEffect(()=>{
        if(config) {
            setCardConfigTmp(config.cardSetting);
            setDayCardColorRangesTMP(convertToArray(config.dayCardColorRanges));
          //  console.log(config.cardSettingLock);
            setCardConfigLockTmp(config.cardSettingLock);
            if(config.dashboard){
                if(config.dashboard.specialtiesSet) {
                    setSelectedSpecialtiesDef([...(_.cloneDeep(config.dashboard.specialtiesSet))]);
                }
                if(config.dashboard.theatersSet) {
                    setSelectedTheatersDef([...(_.cloneDeep(config.dashboard.theatersSet))]);
                }
                buildColorSet();
            }
        }
    },[config])

    const getCardFieldForType = (type) => {
        return type? config?.cardFields.filter(field => field.cardTypes.some(typeCard => typeCard === type)): config?.cardFields;
    }

    const allFieldSelected = (opType, type) => {
        let allSelected = true;

        getCardFieldForType(opType)?.map((field)=> {
            if(!cardPref?.[type]?.[field.key]) allSelected = false;
        })

        return allSelected;
    }

    const [needSave, setNeedSave] = React.useState(false)

    const [cardConfigTmp, setCardConfigTmp] = React.useState(null);
    const [cardConfigLockTmp, setCardConfigLockTmp] = React.useState(null);
    const [iFrameView, setIFrameView] = React.useState(false);
    const [userIsCons, setUserIsCons] = useState(false);
    const [userIsSurgeon, setUserIsSurgeon] = useState(false);
    const [userIsAnaesthetists, setUserIsAnaesthetists] = useState(false);

    useEffect(()=>{
        let params = new URLSearchParams(window.location.search);
        let view = params.get("view");
        if(view === "admissions_iframe" || view === "admissions_patient_iframe")
            setIFrameView(true)

        getConsultantByUserName();

    },[]);


    const getConsultantByUserName = () => {
        let urlConsultant = `/admission/person/consultant?userName=${userObject.userName}`;
        let urlSurgeon = `/admission/person/surgeon?userName=${userObject.userName}`;
        let urlAnaesthetist = `/admission/person/anaesthetist?userName=${userObject.userName}`;

        API.getDictByURL(urlConsultant).then(dictData => {
            if (dictData && !_.isEmpty(dictData)) {
                setUserIsCons(true)
            }
        }).catch(function (error) {
            console.error("Consultant Filter", error);
        });

        API.getDictByURL(urlSurgeon).then(dictData => {
            if (dictData && !_.isEmpty(dictData)) {
                setUserIsSurgeon(true)
            }
        }).catch(function (error) {
            console.error("Surgeons Filter", error);
        });

        API.getDictByURL(urlAnaesthetist).then(dictData => {
            if (dictData && !_.isEmpty(dictData)) {
                setUserIsAnaesthetists(true)
            }
        }).catch(function (error) {
            console.error("Anaesthetists Filter", error);
        });
    }

    const renderItem = (title, type, opType) => {
        return  <Accordion className={classes.accordion}>
            <AccordionSummary
                expandIcon={<ExpandMoreIcon/>}
                aria-controls="panel1a-content-pref"
                id="panel1a-content-pref"
            >
                <Typography className={classes.typography}>
                    <div className={classes.headerContainer}>
                        <div> {title} </div>
                        <Button onClick={(e)=>resetToDefault(e,type)} >{resetText}</Button>
                    </div>
                </Typography>
            </AccordionSummary>
            <AccordionDetails>
                <FormGroup>
                    <FormControlLabel
                        sx={{flex: "center"}}
                        name={"checked"}
                      //  disabled={allFieldSelected(opType, type)}
                        control={
                            <Checkbox
                                checked={allFieldSelected(opType, type)}
                                onChange={(e)=>{
                                    if(e.target.checked) {
                                        getCardFieldForType(opType).map((field)=> {
                                            selectFiled(field, type)
                                        })
                                    } else {
                                        resetToLock(e,type)
                                    }
                            }}/>
                        }
                        label={allFieldSelected(opType, type)? t("Deselect all"): t("Select all")}/>
                </FormGroup>

                {getCardFieldForType(opType)?.map((field, index)=> {
                    return <Chip style={{margin: 2, cursor: (cardConfigLockTmp?.[type][field.key]? "not-allowed": "pointer")}} key={"settings-chip_" + field.key + "_" + index}
                                 avatar={cardConfigLockTmp?.[type][field.key] && <Avatar sx={{ bgcolor: "#D84343" }}> <LockIcon style={{fontSize: 15}}/> </Avatar>}
                                // disabled={cardConfigLockTmp?.[type][field.key] && cardPref?.[type]?.[field.key]}
                                 color={cardConfigLockTmp?.[type][field.key]? "error" : (cardPref?.[type]?.[field.key]? "primary": "secondary")}
                                 onClick={() => {
                                     if(!cardConfigLockTmp?.[type][field.key])
                                         addFiled(field, type)
                                 }} label={field.label}/>

                })}

            </AccordionDetails>
        </Accordion>
    }

    const handleLockEvent = (e, type, key) => {
        setCardConfigLockTmp((pr) => {
            let list = {...pr[type]};
            list[key] = !list[key];
            return {
                ...pr,
                [type]: list
            }
        })
        setCardConfigTmp((pr) => {
            let list = {...pr[type]};
            list[key] = true;
            return {
                ...pr,
                [type]: list
            }
        })
        setNeedSave(true);
        e.stopPropagation();
        e.preventDefault();
    }

    const renderItemDef = (title, type, opType) => {
        return  <Accordion  className={classes.accordion}>
            <AccordionSummary
                expandIcon={<ExpandMoreIcon/>}
                aria-controls="panel1a-content-def"
                id="panel1a-content-def"
            >
                <Typography>{title}</Typography>
            </AccordionSummary>
            <AccordionDetails>

                {getCardFieldForType(opType)?.map((field)=> {
                    return <Chip style={{margin: 2}}
                                 avatar={<Avatar onClick={(e) => handleLockEvent(e, type, field.key)}>{cardConfigLockTmp?.[type][field.key]? <LockIcon style={{fontSize: 15}}/>: <LockOpenIcon style={{fontSize: 15}}/>} </Avatar>}
                                 color={cardConfigTmp?.[type][field.key]? "primary" : "secondary"}
                                 onClick={() => addFiledDef(field, type)} label={field.label}/>

                })}

            </AccordionDetails>
        </Accordion>
    }

    const handleChangeAndSavePreference = (newValue, preferenceName) => {
        dispatch(saveAgylePreference(handleChangePreference(newValue, preferenceName)));
    }

    const handleChangePreference = (newValue, preferenceName) => {
        let preferenceNameArr = preferenceName.split(".");
        let prfTmpObj = {};
        if(preferenceNameArr.length > 1){
            prfTmpObj[preferenceNameArr[0]] = {..._.cloneDeep(agylePreference[preferenceNameArr[0]])};
            let prfTmp = prfTmpObj[preferenceNameArr[0]];
            for(let i = 1; i < preferenceNameArr.length; i++){
                if(i == preferenceNameArr.length - 1){
                    prfTmp[preferenceNameArr[i]] = newValue;
                } else {
                    if(!prfTmp.hasOwnProperty(preferenceNameArr[i])){
                        prfTmp[preferenceNameArr[i]] = {};
                    }
                    prfTmp = prfTmp[preferenceNameArr[i]];
                }
            }
        }
        else {
            prfTmpObj[preferenceNameArr[0]] = {newValue};
        }
        return prfTmpObj;
    }

    const handleChangeConfigDef = (inputVal, field) => {
        let value = inputVal;
        let fieldName = field;
        if((field.split(".")).length > 1){
            const fieldArr = field.split(".");
            fieldName = fieldArr[0];
            value = config.hasOwnProperty(fieldName) ? _.cloneDeep(config[fieldName]) : {};
            for(let i = 1; i < fieldArr.length; i++){
                if(!value.hasOwnProperty(fieldArr[i])){
                    if(i < fieldArr.length - 1) {
                        value[fieldArr[i]] = {};
                    } else {
                        value[fieldArr[i]] = inputVal;
                    }
                } else {
                    if(i == fieldArr.length - 1) {
                        value[fieldArr[i]] = inputVal;
                    }
                }
            }
        }
        AdminAPI.updateMasterRecordFieldData("admissionConfig", fieldName, value).then(result => {
            dispatch(getAdmissionConfig());
            dispatch(setSnackbar({
                type: "success",
                message: "Saved",
            }));
        });
    }

    const renderCustomizationCardTab = () => {
        return (<>
            {renderItem("Unscheduled List Theatres", "tciUnscheduledList","TCI")}
            {renderItem("Schedule List Theatres", "tciScheduleList","TCI")}
            {renderItem("Schedule Theatres Calendar", "tciSchedule","TCI")}
            {renderItem("Schedule List MDU", "mduScheduleList","MDU")}
            {renderItem("Unscheduled List MDU", "mduUnscheduledList","MDU")}
            {renderItem("Schedule MDU Calendar", "mduSchedule","MDU")}
            {renderItem("Search List", "search")}

            <div className={classes.saveButton}>
                <Button onClick={savePref} variant={"contained"} disabled={!needSave}>save card view's</Button>
            </div>

            </>)
    }

    const handleChangeTheme = () => {
        window._switchTheme();
        dispatch(saveCurrentTheme(window._getTheme()));
    }

    const renderCustomizationTab = () => {
        return (<>
            <Accordion  className={classes.accordion}>
                <AccordionSummary
                    expandIcon={<ExpandMoreIcon/>}
                    aria-controls="customization-panel1a-content"
                    id="customization-panel1a-header"
                >
                    <Typography className={classes.typography}>
                        <div className={classes.headerContainer}>
                            <div> View </div>
                            <Button onClick={(e)=>resetToDefaultPref(e, "bookedAdmissions.view", "viewDef")}>
                                {resetText}</Button>
                        </div>
                    </Typography>
                </AccordionSummary>
                <AccordionDetails>

                    <RadioGroup
                        value={agylePreference?.bookedAdmissions?.view}
                        row
                        onChange={(e) => {handleChangeAndSavePreference(e.target.value, "bookedAdmissions.view")}}
                    >
                        <FormControlLabel value={"expand"} control={<Radio/>} label={t("Expand")}/>
                        <FormControlLabel value={"no_expand"} control={<Radio/>} label={t("Not Expand")}/>
                    </RadioGroup>

                </AccordionDetails>
            </Accordion>
            {!iFrameView &&
                <Accordion className={classes.accordion}>
                    <AccordionSummary
                        expandIcon={<ExpandMoreIcon/>}
                        aria-controls="customization-panel2a-content"
                        id="customization-panel2a-header"
                    >
                        <Typography className={classes.typography}>
                            <div className={classes.headerContainer}>
                                <div>  Landing Page </div>
                                <Button onClick={(e) => resetToDefaultPref(e, "bookedAdmissions.landingPage", "defaultLandingPage")}>
                                    {resetText}
                                </Button>
                            </div>
                        </Typography>
                    </AccordionSummary>
                    <AccordionDetails>

                        <RadioGroup
                            value={agylePreference?.bookedAdmissions?.landingPage}
                            row
                            onChange={(e) => {
                                handleChangeAndSavePreference(e.target.value, "bookedAdmissions.landingPage")
                            }}
                        >
                            <FormControlLabel value={"calendar"} control={<Radio/>} label={t("Calendar")}/>
                            <FormControlLabel value={"dashboard"} control={<Radio/>} label={t("Dashboard")}/>
                            <FormControlLabel value={"mySessions"} control={<Radio/>} label={t("My Sessions")}/>
                        </RadioGroup>

                    </AccordionDetails>
                </Accordion>
            }
            <Accordion className={classes.accordion}>
                <AccordionSummary
                    expandIcon={<ExpandMoreIcon/>}
                    aria-controls="customization-panel2a-content"
                    id="customization-panel2a-header"
                >
                    <Typography className={classes.typography}>
                        <div className={classes.headerContainer}>
                            <div>  Default Consultant Filter </div>
                            <Button onClick={(e) => resetToDefaultPref(e, "bookedAdmissions.defaultConsultant", "defaultConsultant")}>
                                {resetText}
                            </Button>
                        </div>
                    </Typography>
                </AccordionSummary>
                <AccordionDetails>
                    <AgyleSwitch
                        name={"defaultConsultantToMe"}
                        value={agylePreference?.bookedAdmissions?.defaultConsultantToMe}
                        disabled={!(userIsCons || userIsSurgeon || userIsAnaesthetists)}
                        onChange={(el)=>{
                            handleChangeAndSavePreference(el.target.checked, "bookedAdmissions.defaultConsultantToMe")}}
                        label={t('Show only my patients and sessions')}
                    />

                </AccordionDetails>
            </Accordion>
            <Accordion className={classes.accordion}>
                <AccordionSummary
                    expandIcon={<ExpandMoreIcon/>}
                    aria-controls="customization-panel2a-content"
                    id="customization-panel2a-header"
                >
                    <Typography className={classes.typography}>
                        <div className={classes.headerContainer}>
                            <div> Theatres  </div>
                            <Button onClick={(e) => resetToDefaultPref(e, "bookedAdmissions.inactiveTheatres", "inactiveTheatres")}>
                                {resetText}
                            </Button>
                        </div>
                    </Typography>
                </AccordionSummary>
                <AccordionDetails>
                    <AgyleSwitch
                        name={"inactiveTheatres"}
                        value={agylePreference?.bookedAdmissions?.inactiveTheatres}
                        onChange={(el)=>{
                            handleChangeAndSavePreference(el.target.checked, "bookedAdmissions.inactiveTheatres")}}
                        label={t('Show inactive Theatres')}
                    />

                </AccordionDetails>
            </Accordion>
            <Accordion className={classes.accordion}>
                <AccordionSummary
                    expandIcon={<ExpandMoreIcon/>}
                    aria-controls="customization-panel2a-content"
                    id="customization-panel2a-header"
                >
                    <Typography className={classes.typography}>
                        <div className={classes.headerContainer}>
                            <div> Procedure Time format </div>
                            <Button onClick={(e) => resetToDefaultPref(e, "bookedAdmissions.timeFormatInMinutes", "timeFormatInMinutes")}>
                                {resetText}
                            </Button>
                        </div>
                    </Typography>
                </AccordionSummary>
                <AccordionDetails>
                    <AgyleSwitch
                        name={"timeFormatInMinutes"}
                        value={agylePreference?.bookedAdmissions?.timeFormatInMinutes}
                        onChange={(el)=>{handleChangeAndSavePreference(el.target.checked, "bookedAdmissions.timeFormatInMinutes")}}
                        label={t('Show procedure Time in minutes')}
                    />

                </AccordionDetails>
            </Accordion>
            <Accordion className={classes.accordion}>
                <AccordionSummary
                    expandIcon={<ExpandMoreIcon/>}
                    aria-controls="customization-panel2a-content"
                    id="customization-panel2a-header"
                >
                    <Typography className={classes.typography}>
                        <div className={classes.headerContainer}>
                            <div> Form default type  </div>
                            <Button onClick={(e) => resetToDefaultPref(e, "bookedAdmissions.defaultFormAdmissionType", "defaultFormAdmissionType")}>
                                {resetText}
                            </Button>
                        </div>
                    </Typography>
                </AccordionSummary>
                <AccordionDetails>
                    <AgyleToggleButtons
                        classNameRoot={baToggleClasses.baToggle_classNameRoot}
                        classNameLabel={baToggleClasses.baToggle_classNameLabel}
                        classNameSelected={baToggleClasses.baToggle_classNameSelected}
                        onChange={(el)=>{handleChangeAndSavePreference(el, "bookedAdmissions.defaultFormAdmissionType")}}
                        value={agylePreference?.bookedAdmissions?.defaultFormAdmissionType}
                        size="small"
                        options={itemsFormTypes}
                        minWidth={100}
                    />

                </AccordionDetails>
            </Accordion>
            <Accordion className={classes.accordion}>
                <AccordionSummary
                    expandIcon={<ExpandMoreIcon/>}
                    aria-controls="customization-panel2a-content"
                    id="customization-panel2a-header"
                >
                    <Typography className={classes.typography}>
                        <div className={classes.headerContainer}>
                            <div> Calendar default type  </div>
                            <Button onClick={(e) => resetToDefaultPref(e, "bookedAdmissions.defaultCalendarAdmissionType", "defaultCalendarAdmissionType")}>
                                {resetText}
                            </Button>
                        </div>
                    </Typography>
                </AccordionSummary>
                <AccordionDetails>
                    <AgyleToggleButtons
                        classNameRoot={baToggleClasses.baToggle_classNameRoot}
                        classNameLabel={baToggleClasses.baToggle_classNameLabel}
                        classNameSelected={baToggleClasses.baToggle_classNameSelected}
                        onChange={(el)=>{handleChangeAndSavePreference(el, "bookedAdmissions.defaultCalendarAdmissionType")}}
                        value={agylePreference?.bookedAdmissions?.defaultCalendarAdmissionType}
                        size="small"
                        options={itemsFormTypes}
                        minWidth={100}
                    />

                </AccordionDetails>
            </Accordion>
            <Accordion className={classes.accordion}>
                <AccordionSummary
                    expandIcon={<ExpandMoreIcon/>}
                    aria-controls="customization-panel2a-content"
                    id="customization-panel2a-header"
                >
                    <Typography className={classes.typography}>
                        <div className={classes.headerContainer}>
                            <div> Theme  </div>
                        </div>
                    </Typography>
                </AccordionSummary>
                <AccordionDetails>
                    <Button onClick={handleChangeTheme}>
                        Switch theme
                    </Button>

                </AccordionDetails>
            </Accordion>
        </>)
    }

    const renderCustomizationCardDefault = () => {
        return (<>
            {renderItemDef("Unscheduled List Theatres", "tciUnscheduledList","TCI")}
            {renderItemDef("Schedule List Theatres", "tciScheduleList","TCI")}
            {renderItemDef("Schedule Theatres Calendar", "tciSchedule","TCI")}
            {renderItemDef("Schedule List MDU", "mduScheduleList","MDU")}
            {renderItemDef("Unscheduled List MDU", "mduUnscheduledList","MDU")}
            {renderItemDef("Schedule MDU Calendar", "mduSchedule","MDU")}
            {renderItemDef("Search List", "search")}


            <div className={classes.saveButton}>
                <Button onClick={savePrefDef} variant={"contained"} disabled={!needSave}>save card view's</Button>
            </div>

        </>)
    }

    const handleChangeColor = (e, index) => {
        setDayCardColorRangesTMP((colorRanges) => {
            let colorRangesTmp = [...colorRanges];
            colorRangesTmp[index].color = e.target.value

            return colorRangesTmp
        })
    }

    const handleRangeColor = (e, index) => {
        setDayCardColorRangesTMP((colorRanges) => {
            let colorRangesTmp = [...colorRanges];
            colorRangesTmp[index].range = e.target.value

            return colorRangesTmp
        })
    }

    const [dayCardColorRangesTMP, setDayCardColorRangesTMP] = React.useState(null)
    const itemsFormTypes = [
        {code: "TCI", description: t("Theatres")},
        {code: "MDU", description: t("MDU")}
    ]
    const baToggleClasses = bookAdmissionToggleStyles();

    const saveDef = () =>{
       // console.log(dayCardColorRangesTMP);
        let obj = {}
        dayCardColorRangesTMP.forEach((dayCardColor) => {
            let key = dayCardColor.range;
            delete dayCardColor.range;
            obj[key] = dayCardColor
        })
        //console.log(obj);

        AdminAPI.updateMasterRecordFieldData("admissionConfig", "dayCardColorRanges", obj).then(result => {
           // console.log(result);
            dispatch(setSnackbar({
                type: "success",
                message: "Saved",
            }));
            dispatch(getAdmissionConfig());
        })
    }

    const renderCustomizationDefault = () => {
        return (<>
            {!iFrameView &&
                <Accordion className={classes.accordion}>
                    <AccordionSummary
                        expandIcon={<ExpandMoreIcon/>}
                        aria-controls="panel1a-content"
                        id="panel1a-header"
                    >
                        <Typography> Default Landing Page </Typography>
                    </AccordionSummary>
                    <AccordionDetails>

                        <RadioGroup
                            value={config?.defaultLandingPage}
                            row
                            onChange={(e) => {
                                handleChangeConfigDef(e.target.value, "defaultLandingPage");
                            }}
                        >
                            <FormControlLabel value={"calendar"} control={<Radio/>} label={t("Calendar")}/>
                            <FormControlLabel value={"dashboard"} control={<Radio/>} label={t("Dashboard")}/>
                        </RadioGroup>

                    </AccordionDetails>
                </Accordion>
            }
            <Accordion  className={classes.accordion}>
                <AccordionSummary
                    expandIcon={<ExpandMoreIcon/>}
                    aria-controls="panel2a-content"
                    id="panel2a-header"
                >
                    <Typography> View Def </Typography>
                </AccordionSummary>
                <AccordionDetails>

                    <RadioGroup
                        value={config?.viewDef}
                        row
                        onChange={(e) => {handleChangeConfigDef(e.target.value, "viewDef")}}
                    >
                        <FormControlLabel value={"expand"} control={<Radio/>} label={t("Expand")}/>
                        <FormControlLabel value={"no_expand"} control={<Radio/>} label={t("Not Expand")}/>
                    </RadioGroup>

                </AccordionDetails>
            </Accordion>

            <Accordion  className={classes.accordion}>
                <AccordionSummary
                    expandIcon={<ExpandMoreIcon/>}
                    aria-controls="panel3a-content"
                    id="panel3a-header"
                >
                    <Typography>Day Card Color Ranges</Typography>
                </AccordionSummary>
                <AccordionDetails>
                    {dayCardColorRangesTMP && dayCardColorRangesTMP.map((colorRanges,index) => {
                        return <Grid container spacing={2} alignItems={"center"}>
                            <Grid item xs = {3}>
                                <TextField
                                    InputLabelProps={{
                                        shrink: true,
                                    }}
                                    size="normal"
                                    variant="outlined"
                                    className={"custom-dt"}
                                    style={{ width: "100%", marginTop: 10 }}
                                    label="Range [%]"
                                    name={"autoClose"}
                                    value={colorRanges.range}
                                    onChange={(e) => handleRangeColor(e, index)}
                                />

                            </Grid>
                            <Grid item xs = {1} style={{textAlign: "center"}}>
                               ->
                            </Grid>
                            <Grid item xs = {6}>
                                <input type="color" id="body" name="body"
                                       onChange={(e)=>handleChangeColor(e, index)}
                                       value={colorRanges.color}/>
                            </Grid>
                        </Grid>
                    })
                    }
                    <Button onClick={saveDef}>SAVE</Button>
                </AccordionDetails>
            </Accordion>
            <Accordion className={classes.accordion}>
                <AccordionSummary
                    expandIcon={<ExpandMoreIcon/>}
                    aria-controls="customization-panel2a-content"
                    id="customization-panel2a-header"
                >
                    <Typography className={classes.typography}>
                        <div className={classes.headerContainer}>
                            <div> Theatres  </div>
                        </div>
                    </Typography>
                </AccordionSummary>
                <AccordionDetails>
                    <AgyleSwitch
                        name={"inactiveTheatres"}
                        value={config?.inactiveTheatres}
                        onChange={(e) => {handleChangeConfigDef(e.target.checked, "inactiveTheatres")}}
                        label={t('Show inactive Theatres')}
                    />

                </AccordionDetails>
            </Accordion>
            <Accordion className={classes.accordion}>
                <AccordionSummary
                    expandIcon={<ExpandMoreIcon/>}
                    aria-controls="customization-panel2a-content"
                    id="customization-panel2a-header"
                >
                    <Typography className={classes.typography}>
                        <div className={classes.headerContainer}>
                            <div> Procedure Time format  </div>
                        </div>
                    </Typography>
                </AccordionSummary>
                <AccordionDetails>
                    <AgyleSwitch
                        name={"timeFormatInMinutes"}
                        value={config?.timeFormatInMinutes}
                        onChange={(e) => {handleChangeConfigDef(e.target.checked, "timeFormatInMinutes")}}
                        label={t('Show procedure Time in minutes')}
                    />

                </AccordionDetails>
            </Accordion>
            <Accordion className={classes.accordion}>
                <AccordionSummary
                    expandIcon={<ExpandMoreIcon/>}
                    aria-controls="customization-panel2a-content"
                    id="customization-panel2a-header"
                >
                    <Typography className={classes.typography}>
                        <div className={classes.headerContainer}>
                            <div> Form default type  </div>
                        </div>
                    </Typography>
                </AccordionSummary>
                <AccordionDetails>
                    <AgyleToggleButtons
                        classNameRoot={baToggleClasses.baToggle_classNameRoot}
                        classNameLabel={baToggleClasses.baToggle_classNameLabel}
                        classNameSelected={baToggleClasses.baToggle_classNameSelected}
                        onChange={(e) => {handleChangeConfigDef(e, "defaultFormAdmissionType")}}
                        value={config?.defaultFormAdmissionType}
                        size="small"
                        options={itemsFormTypes}
                        minWidth={100}
                    />

                </AccordionDetails>
            </Accordion>
            <Accordion className={classes.accordion}>
                <AccordionSummary
                    expandIcon={<ExpandMoreIcon/>}
                    aria-controls="customization-panel2a-content"
                    id="customization-panel2a-header"
                >
                    <Typography className={classes.typography}>
                        <div className={classes.headerContainer}>
                            <div> Calendar default type  </div>
                        </div>
                    </Typography>
                </AccordionSummary>
                <AccordionDetails>
                    <AgyleToggleButtons
                        classNameRoot={baToggleClasses.baToggle_classNameRoot}
                        classNameLabel={baToggleClasses.baToggle_classNameLabel}
                        classNameSelected={baToggleClasses.baToggle_classNameSelected}
                        onChange={(e) => {handleChangeConfigDef(e, "defaultCalendarAdmissionType")}}
                        value={config?.defaultCalendarAdmissionType}
                        size="small"
                        options={itemsFormTypes}
                        minWidth={100}
                    />

                </AccordionDetails>
            </Accordion>
        </>)
    }

    const theatres = useSelector(getAllTheatresDict);
    const specialties = useSelector(getSpecialtiesDict);
    const [selectedSpecialties, setSelectedSpecialties] = React.useState([]);
    const [selectedSpecialtiesColor, setSelectedSpecialtiesColor] = React.useState({});
    const [selectedSpecialtiesDef, setSelectedSpecialtiesDef] = React.useState([]);
    const [selectedSpecialtiesColorDef, setSelectedSpecialtiesColorDef] = React.useState({});
    const [selectedTheaters, setSelectedTheaters] = React.useState([]);
    const [selectedTheatersColor, setSelectedTheatersColor] = React.useState({});
    const [selectedTheatersDef, setSelectedTheatersDef] = React.useState([]);
    const [selectedTheatersColorDef, setSelectedTheatersColorDef] = React.useState({});

    const buildColorSet = () => {
        if(config?.dashboard?.specialtiesSet) {
            let sSpecColor = {};
            _.forEach(config.dashboard.specialtiesSet, (specItem) => {
                sSpecColor[specItem.__id] = "primary";
            })
            setSelectedSpecialtiesColorDef(sSpecColor);
        }
        if(config?.dashboard?.theatersSet) {
            let sTheaterColor = {};
            _.forEach(config.dashboard.theatersSet, (theaterItem) => {
                sTheaterColor[theaterItem.__id] = "primary";
            })
            setSelectedTheatersColorDef(sTheaterColor);
        }
        if(agylePreference?.bookedAdmissions?.dashboard?.specialtiesSet) {
            let sSpecColor = {};
            _.forEach(agylePreference.bookedAdmissions.dashboard.specialtiesSet, (specItem) => {
                sSpecColor[specItem.__id] = "primary";
            })
            setSelectedSpecialtiesColor(sSpecColor);
        }
        if(agylePreference?.bookedAdmissions?.dashboard?.theatersSet) {
            let sTheaterColor = {};
            _.forEach(agylePreference.bookedAdmissions.dashboard.theatersSet, (theaterItem) => {
                sTheaterColor[theaterItem.__id] = "primary";
            })
            setSelectedTheatersColor(sTheaterColor);
        }
    }

    const addDashboardArrayItem = (kind, item, idDefault = true) => {
        switch(kind){
            case "specialties":
                let sSpec = idDefault ? _.cloneDeep(selectedSpecialtiesDef) : _.cloneDeep(selectedSpecialties);
                const itemSpecIdx =  _.findIndex(sSpec, (arrSpec) => {
                    return arrSpec.__id == item.__id;
                })
                if(itemSpecIdx < 0){
                    sSpec.push(item);
                } else {
                    sSpec.splice(itemSpecIdx, 1);
                }
                if(sSpec.length == specialties.length){
                    if(idDefault) {
                        handleChangeConfigDef(true, "dashboard.specialtiesAll");
                    } else {
                        handleChangeAndSavePreference(true, "bookedAdmissions.dashboard.specialtiesAll");
                    }
                } else {
                    if(idDefault) {
                        handleChangeConfigDef(sSpec, "dashboard.specialtiesSet");
                    } else {
                        handleChangeAndSavePreference(sSpec, "bookedAdmissions.dashboard.specialtiesSet");
                    }
                }
                break;
            case "theaters":
                let sTheater = idDefault ? _.cloneDeep(selectedTheatersDef) : _.cloneDeep(selectedTheaters);
                const itemTheaterIdx =  _.findIndex(sTheater, (arrTheaters) => {
                    return arrTheaters.__id == item.__id;
                })
                if(itemTheaterIdx < 0){
                    sTheater.push(item);
                } else {
                    sTheater.splice(itemTheaterIdx, 1);
                }
                if(sTheater.length == theatres.length){
                    if(idDefault) {
                        handleChangeConfigDef(true, "dashboard.theatersSet");
                    } else {
                        handleChangeAndSavePreference(true, "bookedAdmissions.dashboard.theatersSet");
                    }
                } else {
                    if(idDefault) {
                        handleChangeConfigDef(sTheater, "dashboard.theatersSet");
                    } else {
                        handleChangeAndSavePreference(sTheater, "bookedAdmissions.dashboard.theatersSet");
                    }
                }
                break;
        }
    }

    const renderCustomizationDashboard = (type= "user") => {
        return (
            <>
                <Accordion  className={classes.accordion}>
                    <AccordionSummary
                        expandIcon={<ExpandMoreIcon/>}
                        aria-controls={type + "_dashboard_panel1a-content"}
                        id={type + "_dashboard_panel1a-header"}
                    >
                        <Typography className={classes.typography}>
                                <div className={classes.headerContainer}>
                                    <div> {t("Default Theatres Set")}</div>
                                {type == "user" &&
                                <Button onClick={(e) => {
                                    resetToDefaultPref(e, "bookedAdmissions.dashboard.theatersAll", "dashboard.theatersAll");
                                    resetToDefaultPref(e, "bookedAdmissions.dashboard.theatersSet", "dashboard.theatersSet")}}>
                                    {resetText}
                                </Button>
                                }
                                </div>
                        </Typography>
                    </AccordionSummary>
                    <AccordionDetails>
                        <FormGroup>
                            <FormControlLabel
                                sx={{flex: "center"}}
                                name={"checked"}
                                control={
                                    type == "user" ?
                                    <Checkbox
                                        checked={agylePreference?.bookedAdmissions?.dashboard?.theatersAll}
                                        onChange={(e)=>{
                                            handleChangeAndSavePreference(e.target.checked, "bookedAdmissions.dashboard.theatersAll");
                                        }}/> :
                                    <Checkbox
                                        checked={config?.dashboard?.theatersAll}
                                        onChange={(e)=>{
                                            handleChangeConfigDef(e.target.checked, "dashboard.theatersAll");
                                        }}/>
                                }
                                label={((type === "user" && agylePreference?.bookedAdmissions?.dashboard?.theatersAll) ||
                                    (type !== "user" && config?.dashboard?.theatersAll))?
                                    t("Deselect all") : t("Select all")}/>
                        </FormGroup>

                        {theatres?.map((theater, index)=> {
                            if(type == "user") {
                                return <Chip style={{margin: 2}} key={"settings-theater-chip_" + index}
                                             disabled={agylePreference?.bookedAdmissions?.dashboard?.theatersAll}
                                             color={selectedTheatersColor[theater.__id] || agylePreference?.bookedAdmissions?.dashboard?.theatersAll ? "primary" : "secondary"}
                                             onClick={() => addDashboardArrayItem("theaters", theater, false)}
                                             label={theater.description}/>
                            } else {
                                return <Chip style={{margin: 2}} key={"settings-theater-chip_" + index}
                                             disabled={config?.dashboard?.theatersAll}
                                             color={selectedTheatersColorDef[theater.__id] || config?.dashboard?.theatersAll ? "primary" : "secondary"}
                                             onClick={() => addDashboardArrayItem("theaters", theater)}
                                             label={theater.description}/>;
                            }
                        })}

                    </AccordionDetails>
                </Accordion>
                <Accordion  className={classes.accordion}>
                    <AccordionSummary
                        expandIcon={<ExpandMoreIcon/>}
                        aria-controls={type + "_dashboard_panel2a-content"}
                        id={type + "_dashboard_panel1a-header"}
                    >
                        <Typography className={classes.typography}>
                            <div className={classes.headerContainer}>
                                <div>{t("Default Specialties Set")} </div>
                            {type == "user" &&
                                <Button onClick={(e) => {
                                    resetToDefaultPref(e, "bookedAdmissions.dashboard.specialtiesAll", "dashboard.specialtiesAll");
                                    resetToDefaultPref(e, "bookedAdmissions.dashboard.specialtiesSet", "dashboard.specialtiesSet")}}>
                                    {resetText}</Button>
                            }
                            </div>
                        </Typography>
                    </AccordionSummary>
                    <AccordionDetails>
                        <FormGroup>
                            <FormControlLabel
                                sx={{flex: "center"}}
                                name={"checked"}
                                control={
                                    type == "user" ?
                                        <Checkbox
                                            checked={agylePreference?.bookedAdmissions?.dashboard?.specialtiesAll}
                                            onChange={(e)=>{
                                                handleChangeAndSavePreference(e.target.checked, "bookedAdmissions.dashboard.specialtiesAll");
                                            }}/> :
                                        <Checkbox
                                            checked={config?.dashboard?.specialtiesAll}
                                            onChange={(e)=>{
                                                handleChangeConfigDef(e.target.checked, "dashboard.specialtiesAll");
                                            }}/>
                                }
                                label={((type === "user" && agylePreference?.bookedAdmissions?.dashboard?.specialtiesAll) ||
                                    (type !== "user" && config?.dashboard?.specialtiesAll))?
                                    t("Deselect all") : t("Select all")}/>
                        </FormGroup>

                        {specialties?.map((spec, index)=> {
                            if(type == "user") {
                                return <Chip style={{margin: 2}} key={"settings-specialty-chip_" + index}
                                             avatar={<Avatar> {spec.__code} </Avatar>}
                                             disabled={agylePreference?.bookedAdmissions?.dashboard?.specialtiesAll}
                                             color={selectedSpecialtiesColor[spec.__id] || agylePreference?.bookedAdmissions?.dashboard?.specialtiesAll ? "primary" : "secondary"}
                                             onClick={() => addDashboardArrayItem("specialties", spec, false)}
                                             label={spec.__description}/>
                            } else {
                                return <Chip style={{margin: 2}} key={"settings-specialty-chip_" + index}
                                             avatar={<Avatar> {spec.__code} </Avatar>}
                                             disabled={config?.dashboard?.specialtiesAll}
                                             color={selectedSpecialtiesColorDef[spec.__id] || config?.dashboard?.specialtiesAll ? "primary": "secondary"}
                                             onClick={() => addDashboardArrayItem("specialties", spec)} label={spec.__description}/>
                            }



                        })}
                    </AccordionDetails>
                </Accordion>
                <Accordion  className={classes.accordion}>
                    <AccordionSummary
                        expandIcon={<ExpandMoreIcon/>}
                        aria-controls={type + "_dashboard_panel3a-content"}
                        id={type + "_dashboard_panel2a-header"}
                    >
                        <Typography className={classes.typography}>
                            <div className={classes.headerContainer}>
                                <div>{t("Default Time Range")} </div>
                            {type == "user" &&
                            <Button onClick={(e) => resetToDefaultPref(e, "bookedAdmissions.dashboard.timeRange", "dashboard.timeRange")}>
                                {resetText}</Button>
                            }
                            </div>
                        </Typography>
                    </AccordionSummary>
                    <AccordionDetails>
                        {type == "user" &&
                            <RadioGroup
                                value={agylePreference?.bookedAdmissions?.dashboard?.timeRange}
                                row
                                onChange={(e) => handleChangeAndSavePreference(e.target.value, "bookedAdmissions.dashboard.timeRange")}
                            >
                                <FormControlLabel value={"day"} control={<Radio/>} label={t("Day")}/>
                                <FormControlLabel value={"week"} control={<Radio/>} label={t("Week")}/>
                            </RadioGroup>
                        }
                        {type != "user" &&
                            <RadioGroup
                                value={config?.dashboard?.timeRange}
                                row
                                onChange={(e) => handleChangeConfigDef(e.target.value, "dashboard.timeRange")}
                            >
                                <FormControlLabel value={"day"} control={<Radio/>} label={t("Day")}/>
                                <FormControlLabel value={"week"} control={<Radio/>} label={t("Week")}/>
                            </RadioGroup>
                        }
                    </AccordionDetails>
                </Accordion>
                <Accordion  className={classes.accordion}>
                    <AccordionSummary
                        expandIcon={<ExpandMoreIcon/>}
                        aria-controls={type + "_dashboard_panel4a-content"}
                        id={type + "_dashboard_panel4a-header"}
                    >
                        <Typography className={classes.typography}>
                            <div className={classes.headerContainer}>
                                <div>{t("Default Workload")}</div>
                            {type == "user" &&
                            <Button onClick={(e) => resetToDefaultPref(e, "bookedAdmissions.dashboard.workload", "dashboard.workload")}>
                                {resetText}</Button>
                            }
                            </div>
                        </Typography>
                    </AccordionSummary>
                    <AccordionDetails>
                        {type == "user" &&
                        <RadioGroup
                            value={agylePreference?.bookedAdmissions?.dashboard?.workload}
                            row
                            onChange={(e) => handleChangeAndSavePreference(e.target.value, "bookedAdmissions.dashboard.workload")}
                        >
                            {Object.keys(WorkloadTypes).map((workloadKey, indexWT) => {
                                return (<FormControlLabel value={workloadKey} control={<Radio/>}
                                                          label={t(WorkloadTypes[workloadKey])}
                                                          key={"workloadType_" + indexWT}/>);
                            })}
                        </RadioGroup>
                        }
                        {type != "user" &&
                        <RadioGroup
                            value={config?.dashboard?.workload}
                            row
                            onChange={(e) => handleChangeConfigDef(e.target.value, "dashboard.workload")}
                        >
                            {Object.keys(WorkloadTypes).map((workloadKey, indexWT) => {
                                return (<FormControlLabel value={workloadKey} control={<Radio/>}
                                                          label={t(WorkloadTypes[workloadKey])}
                                                          key={"workloadType_" + indexWT}/>);
                            })}
                        </RadioGroup>
                        }
                    </AccordionDetails>
                </Accordion>
                <Accordion  className={classes.accordion}>
                    <AccordionSummary
                        expandIcon={<ExpandMoreIcon/>}
                        aria-controls={type + "_dashboard_panel5a-content"}
                        id={type + "_dashboard_panel5a-header"}
                    >
                        <Typography className={classes.typography}>
                            <div className={classes.headerContainer}>
                                <div>{t("Default Session Type")}</div>
                            {type == "user" &&
                            <Button onClick={(e) => resetToDefaultPref(e, "bookedAdmissions.dashboard.sessionType", "dashboard.sessionType")}>
                                {resetText}</Button>
                            }
                            </div>
                        </Typography>
                    </AccordionSummary>
                    <AccordionDetails>
                        {type == "user" &&
                        <RadioGroup
                            value={agylePreference?.bookedAdmissions?.dashboard?.sessionType}
                            row
                            onChange={(e) => handleChangeAndSavePreference(e.target.value, "bookedAdmissions.dashboard.sessionType")}
                        >
                            {Object.keys(ShowOptionTypes).map((showOptionKey, indexSO) => {
                                return (<FormControlLabel value={showOptionKey} control={<Radio/>}
                                                          label={t(ShowOptionTypes[showOptionKey])}
                                                          key={"showOptionType_" + indexSO}/>);
                            })}
                        </RadioGroup>
                        }
                        {type != "user" &&
                        <RadioGroup
                            value={config?.dashboard?.sessionType}
                            row
                            onChange={(e) => handleChangeConfigDef(e.target.value, "dashboard.sessionType")}
                        >
                            {Object.keys(ShowOptionTypes).map((showOptionKey, indexSO) => {
                                return (<FormControlLabel value={showOptionKey} control={<Radio/>}
                                                          label={t(ShowOptionTypes[showOptionKey])}
                                                          key={"showOptionType_" + indexSO}/>);
                            })}
                        </RadioGroup>
                        }

                    </AccordionDetails>
                </Accordion>
                <Accordion  className={classes.accordion}>
                    <AccordionSummary
                        expandIcon={<ExpandMoreIcon/>}
                        aria-controls={type + "_dashboard_panel6a-content"}
                        id={type + "_dashboard_panel6a-header"}
                    >
                        <Typography className={classes.typography}>
                            <div className={classes.headerContainer}>
                                <div>{t("Default Table Data View")}</div>
                            {type == "user" &&
                            <Button onClick={(e) => resetToDefaultPref(e, "bookedAdmissions.dashboard.tableDataView", "dashboard.tableDataView")}>
                                {resetText}</Button>
                            }
                            </div>
                        </Typography>
                    </AccordionSummary>
                    <AccordionDetails>
                        {type == "user" &&
                        <RadioGroup
                            value={agylePreference?.bookedAdmissions?.dashboard?.tableDataView}
                            row
                            onChange={(e) => handleChangeAndSavePreference(e.target.value, "bookedAdmissions.dashboard.tableDataView")}
                        >
                            <FormControlLabel value={"chart"} control={<Radio/>} label={t("Chart")}/>
                            <FormControlLabel value={"table"} control={<Radio/>} label={t("Table")}/>
                        </RadioGroup>
                        }
                        {type != "user" &&
                        <RadioGroup
                            value={config?.dashboard?.tableDataView}
                            row
                            onChange={(e) => handleChangeConfigDef(e.target.value, "dashboard.tableDataView")}
                        >
                            <FormControlLabel value={"chart"} control={<Radio/>} label={t("Chart")}/>
                            <FormControlLabel value={"table"} control={<Radio/>} label={t("Table")}/>
                        </RadioGroup>
                        }

                    </AccordionDetails>
                </Accordion>
            </>
        )
    }

    const handleTabChange = (item) => {
        setSelectedTab(item.title)
        handleSetCardPref()
        setCardConfigTmp(config.cardSetting);
        setDayCardColorRangesTMP(convertToArray(config.dayCardColorRanges))
        setNeedSave(false)
    }

    const renderSettingTab = () => {
        switch (selectedTab) {
            case "Customization Cards":
                return  renderCustomizationCardTab();
            case "Customization":
                return  renderCustomizationTab();
            case "Customization Default Cards Settings":
                if(canConfigureDefaults) {
                    return renderCustomizationCardDefault();
                } else {
                    return (<></>);
                }
            case "Customization Default Settings":
                if(canConfigureDefaults) {
                    return  renderCustomizationDefault();
                } else {
                    return (<></>);
                }
            case "Customization Dashboard":
                return  renderCustomizationDashboard("user");
            case "Customization Dashboard Default Settings":
                if(canConfigureDefaults) {
                    return  renderCustomizationDashboard("default");
                } else {
                    return (<></>);
                }
            default:
                return "no tab"
        }
    }
    return(<>
            <div style={{display: "flex"}}>
                <div className={classes.menu}>
                    <List>
                        {menuItem.map((item)=> {
                            return <ListItem >
                                <ListItemButton className={clsx(classes.menuItem, item.title === selectedTab && classes.menuItemSelected )}
                                                onClick={()=>handleTabChange(item)}>
                                    {item.title}
                                </ListItemButton>
                            </ListItem>
                        })}
                    </List>
                </div>
                <div className={clsx(classes.content, "scroll-normal-white")}>
                    {renderSettingTab()}
                </div>
            </div>
    </>
    );
}

export default SettingsModal